import React from "react";
import { Row, Col, Card, Empty } from "antd";
import { dashboardKey } from "./../constants/index";
import PizzaChart from "./pizzaChart";
import HorizontalBarChart from "./horizontalBarChart";
import MultipleBarChart from "./multipleBarChart";
import MultipleLineChart from "./multipleLineChart";
import SpeedomerChart from "./speedometerChart";
import MultipleSpeedometer from "./multipleSpeedometer";
import Widgets from "./widgets";
import { TableChart } from "./tableChart";
import { NestedTableChart } from "./nestedTable";
import ProportionBarChart from "./proportionBarChart";
import BarChartWithPercentage from "./barChartWithPercentage";

const getData = (props, data) => {
    const [firstElement, ...remaining] = props;
    const dataDashboard = data[firstElement];
    if (!dataDashboard) return null;
    else if (props.length === 1) return dataDashboard;
    else return getData(remaining, dataDashboard);
};

const RenderItems = ({ item, dataSource }) => {
    const data = item.data && item.data.length !== 0 && dataSource ? getData(item.data, dataSource) : null;

    switch (item.type) {
        case dashboardKey.pizza:
            return <PizzaChart metadata={item} dataSource={data || []} />;

        case dashboardKey.horizontalBar:
            return <HorizontalBarChart metadata={item} dataSource={data} />;
            
        case dashboardKey.proportionBar:
            return <ProportionBarChart metadata={item} dataSource={data} />;
            
        case dashboardKey.barChartWithPercentage:
            return <BarChartWithPercentage metadata={item} dataSource={data} />;

        case dashboardKey.multipleBar:
            return <MultipleBarChart metadata={item} dataSource={data || []} />;

        case dashboardKey.multipleLine:
            return <MultipleLineChart metadata={item} dataSource={data || []} />;

        case dashboardKey.speedometer:
            return <SpeedomerChart metadata={item} dataSource={data} />;

        case dashboardKey.multipleSpeedometer:
            return <MultipleSpeedometer metadata={item} dataSource={data} />;

        case dashboardKey.widgets:
            return <Widgets metadata={item} dataSource={data} />;

        case dashboardKey.nestedTable:
            return <NestedTableChart metadata={item} dataSource={data} />;

        case dashboardKey.table:
            return <TableChart metadata={item} dataSource={data} />;

        default:
            return <div>Nenhum gráfico definido</div>;
    }
};

const RenderDashboard = ({ metadata, dataSource }) => {
    if (!metadata) {
        return (
            <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 32 }]}>
                <Col xs={24} md={24}>
                    <Card size="small">
                        <Empty description={"Sem dados"} />
                    </Card>
                </Col>
            </Row>
        );
    }
    return (
        <>
            <Row gutter={[16, 16]}>
                {!metadata.elements || metadata.elements.length === 0 ? (
                    <Col xs={24} md={24}>
                        <Card size="small">
                            <Empty description={"Sem elementos para apresentar"} />
                        </Card>
                    </Col>
                ) : (
                    metadata.elements.map((item) => {
                        if (item.type === dashboardKey.group) {
                            return (
                                <Row gutter={[16, 16]}>
                                    {item.elements.map((_item) => (
                                        <RenderItems item={_item} dataSource={dataSource} />
                                    ))}
                                </Row>
                            );
                        } else {
                            return <RenderItems item={item} dataSource={dataSource} />;
                        }
                    })
                )}
            </Row>
        </>
    );
};

export default RenderDashboard;
